import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteUser } from '../services/users';
import { userKeys } from './useUsersQuery';
import { handleUserMutationError } from '../services/userErrorHandler';

export const useDeleteUserMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, string>({
        mutationFn: (id) => deleteUser(id),
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({ queryKey: userKeys.lists() });
            queryClient.removeQueries({ queryKey: userKeys.detail(id) });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
